// JS
import React, { useState, useEffect } from 'react';
import {
  devOrProd,
  getInternationalPriceNuqlium,
  ppHeadingOverridesOpen
} from '../shared/utils';
import { gaAddToCart } from '../shared/logic';

//import Button from '../Button';
import MiniBasketPreview from '../MiniBasketPreview';
import ProductSizesPopup from '../ProductSizesPopup';
//import ChristmasDeliveryCutoff from '../ChistmasDeliveryCutoff';

/* SIZE GUIDES - PIM */
import {
  prodCat,
  whatIsTheSizeItem,
  whatIsTheSizeSelected
} from '../shared/pimSizeGuideData';

// COMP
const ProductSizes = ({
  data,
  gaAddToCartData,
  dataPDPMessage,
  reset,
  prodSku,
  setProdSku,
  isMobile,
  sizeError,
  setSizeError,
  sizeSelect,
  setSizeSelect,
  sizeGuideSelect,
  setSizeGuideSelect,
  checkSizeSelected,
  currency,
  userSession
}) => {
  //const uniqueId = Number(new Date());
  const [atbButtonTxt, setAtbButtonTxt] = useState('Select size');
  // Mini Basket - Preview
  const [showHideMiniBasket, setShowHideMiniBasket] = useState(false);
  const [miniBasketProdId, setMiniBasketProdId] = useState(null);
  const [miniBasketSize, setMiniBasketSize] = useState(null);
  const [miniBasketProdSku, setMiniBasketProdSku] = useState(null);
  // Size Guide - Popup
  const [showHideSizeGuide, setShowHideSizeGuide] = useState(false);
  // Model Wears
  const modelWears = data?.product?.attributes?.modelwears;

  const [productSize, setProductSize] = useState(0);

  useEffect(() => {
    if (reset) {
      setProdSku(null);
      setSizeSelect(null);
    }
  }, [reset, setProdSku, setSizeSelect]);

  // Open Size Guide Popup
  const openSizeGuide = () => {
    setShowHideSizeGuide(true);
    window.scrollLock();
  };

  // Add to Basket - Elite
  const addToBasketViaElite = (e) => {
    console.log('Adding to basket: ', prodSku);
    setAtbButtonTxt('Adding to bag...');

    if (typeof window.ajaxAddToBasketSimpleAjx === 'function') {
      window.ajaxAddToBasketSimpleAjx(prodSku, 1); // Run Elite Add To Basket
      setAtbButtonTxt('Added');
      setSizeSelect(null);
      setProdSku(null);
      // Mini Basket - Preview
      setShowHideMiniBasket(true);
      setMiniBasketProdId(data.product.productid);
      setTimeout(function () {
        setAtbButtonTxt('Select size');
      }, 3500);
    } else {
      setAtbButtonTxt('Add to bag error!');
      setTimeout(function () {
        setAtbButtonTxt('Select size');
      }, 2500);
    }
  };

  useEffect(() => {
    document.getElementById('product-sizes-button-id').onclick = function () {
      ppHeadingOverridesOpen();
    };
  }, []);

  // MONETATE TESTS
  const monetateSizeGuide = () => {
    return window.showSizeGuide;
  };

  const monetateSizeSelected = () => {
    return window.showMonetateSizeSelected;
  };

  // SIZE GUIDE - PIM - SHOW USING URL PARAMS
  function hasQueryParams() {
    return window.location.href.indexOf('?showNewSizeGuide') > 0;
  }

  const devOrProdCatList = () => {
    return (
      //monetateSizeGuide() &&
      /*(devOrProd === 'dev' || monetateSizeGuide() || hasQueryParams()) &&*/
      prodCat.some((el) => data.product.categorylist.includes(el)) &&
      (sizeSelect === null && setSizeSelect(data.product.options[0].sku),
      sizeSelect === null &&
        setProdSku(
          data.product.options[0].stock >= 1 ? data.product.options[0].sku : ''
        ),
      sizeSelect === null &&
        setSizeGuideSelect(
          data.product.options[0].attributes.non_mapped_size[0]
        ),
      sizeSelect === null &&
        setMiniBasketSize(
          data.product.options[0].attributes.non_mapped_size[0]
        ),
      sizeSelect === null && setMiniBasketProdSku(data.product.options[0].sku),
      sizeSelect === null &&
        setAtbButtonTxt(
          data.product.options[0].stock >= 1 ? 'Add to bag' : 'Select Size'
        ),
      sizeSelect === null && setProductSize(0),
      setSizeError(''))
    );
  };

  const whatIsTheSizeLocation = () => {
    return whatIsTheSizeItem().map((answer, index) => {
      return (
        <p
          key={'location[' + index + ']'}
          className="product-sizes-selected-size"
        >
          {answer[whatIsTheSizeSelected(sizeGuideSelect)]?.uk && (
            <>
              UK {answer[whatIsTheSizeSelected(sizeGuideSelect)]?.uk}
              <span>
                US {answer[whatIsTheSizeSelected(sizeGuideSelect)]?.us}
              </span>
              <span>
                EU {answer[whatIsTheSizeSelected(sizeGuideSelect)]?.eu}
              </span>
            </>
          )}
        </p>
      );
    });
  };

  return (
    <>
      {showHideMiniBasket && (
        <MiniBasketPreview
          miniBasketProdId={miniBasketProdId}
          setMiniBasketProdId={setMiniBasketProdId}
          showHideMiniBasket={showHideMiniBasket}
          setShowHideMiniBasket={setShowHideMiniBasket}
          userSession={userSession}
          miniBasketSize={miniBasketSize}
          miniBasketProdSku={miniBasketProdSku}
          QVMBPopup={false}
          setSizeSelect={setSizeSelect}
          setProdSku={setProdSku}
        />
      )}
      {showHideSizeGuide && (
        <ProductSizesPopup
          showHideSizeGuide={showHideSizeGuide}
          setShowHideSizeGuide={setShowHideSizeGuide}
          isMobile={isMobile}
          data={data}
          setProdSku={setProdSku}
          sizeSelect={sizeSelect}
          setSizeSelect={setSizeSelect}
          sizeGuideSelect={sizeGuideSelect}
          setSizeGuideSelect={setSizeGuideSelect}
          setMiniBasketSize={setMiniBasketSize}
          setMiniBasketProdSku={setMiniBasketProdSku}
          setAtbButtonTxt={setAtbButtonTxt}
          devOrProd={devOrProd}
          prodCat={prodCat}
          monetateSizeGuide={monetateSizeGuide}
          hasQueryParams={hasQueryParams}
          productSize={productSize}
          setProductSize={setProductSize}
        />
      )}
      <div className="product-sizes">
        {data && data.product && (
          <>
            <div className="product-sizes-button">
              <div className="product-sizes-title">
                <p>Sizes</p>
                {(devOrProd === 'dev' || monetateSizeSelected()) &&
                  data.product.categorylist.includes('FM_SNEAKERS') &&
                  sizeGuideSelect &&
                  whatIsTheSizeLocation()}
                {modelWears && modelWears[0].includes('size') && (
                  <p className="product-sizes-model-wears">{modelWears[0]}</p>
                )}
              </div>
              <a
                id="product-sizes-button-id"
                onClick={() => {
                  openSizeGuide();
                  devOrProdCatList();
                }}
              >
                Size Guide
              </a>
            </div>
            <div className="sizes-scroll-wrapper">
              {data.product.options.map((sizes, i) => (
                <span key={'size-key[' + i + ']'}>
                  {sizes.attributes && (
                    <div
                      tabIndex={0}
                      role="button"
                      aria-pressed={sizes.sku === sizeSelect ? 'true' : 'false'}
                      aria-label="Select a size"
                      className={
                        sizes.stock <= 0
                          ? 'size-wrapper disabled'
                          : sizes.sku === sizeSelect
                          ? 'size-wrapper selected'
                          : 'size-wrapper ' + sizeError
                      }
                      onClick={() => {
                        setSizeSelect(sizes.sku);
                        setProdSku(sizes.sku);
                        setSizeGuideSelect(sizes.attributes.non_mapped_size[0]);
                        setMiniBasketSize(sizes.attributes.non_mapped_size[0]);
                        setMiniBasketProdSku(sizes.sku);
                        setAtbButtonTxt('Add to bag');
                        setSizeError(''); // Clear size error
                        setProductSize(i);
                      }}
                      onMouseOver={() => {
                        setSizeError(''); // Clear size error
                      }}
                    >
                      <span className="size-value">
                        {sizes.attributes.non_mapped_size[0]}
                      </span>
                    </div>
                  )}
                </span>
              ))}
            </div>

            {!isMobile && getInternationalPriceNuqlium() === 'retail_gbp' && (
              <>
                <div className="pdp-general-message">
                  {dataPDPMessage?.pdp_message}
                </div>
                <div id="monetateHook" className="block"></div>
              </>
            )}

            <button
              aria-label="Add to Bag"
              id="main-add-to-bag-btn"
              className="block w-full h-auto py-8 px-12 text-md text-white text-center font-bold uppercase border border-solid border-black bg-black transition ease-in-out duration-400 tracking-widest"
              data-type="seven-pdp-main-basket"
              data-id={data.product.productid}
              data-sku={prodSku}
              data-list="Product Page"
              data-image={data.product.image}
              data-brand={data.product.attributes.brand_name}
              data-category={data.product.attributes.product_category[0]}
              data-name={data.product.name}
              data-price={data.product.option.priceasnumber}
              data-promotion-price={data.product.option.promotionpriceasnumber}
              data-quantity={1}
              data-variant={
                data.product.attributes.colour &&
                data.product.attributes.colour[0]
              }
              data-currency={currency}
              data-size-selected={sizeSelect ? true : false}
              data-onsale={data.product.option.onsale}
              onClick={(e) => {
                checkSizeSelected(false); // Check size is selected
                gaAddToCart(gaAddToCartData);
                prodSku && sizeSelect && addToBasketViaElite(e);
                if (atbButtonTxt === 'Add to bag') {
                  ppHeadingOverridesOpen();
                }
              }}
              disabled={!data.product.instock}
            >
              {!data.product.instock
                ? 'Out of stock'
                : sizeError
                ? 'Select Size'
                : atbButtonTxt}
            </button>

            {/*<ChristmasDeliveryCutoff cutoff={'Dec 21, 2023'} time={'12:00'} />*/}
            {/*<ChristmasDeliveryCutoff />*/}

            {/*
              <Button
                gaAriaLabel="Add to Bag"
                id={'button-id-' + uniqueId}
                gaDataType="seven-pdp-main-basket"
                gaBlockId={data.product.productid}
                gaProdSku={prodSku}
                gaList="Product Page"
                gaImage={data.product.image}
                gaBrand={data.product.attributes.brand}
                gaCategory={data.product.attributes.product_category[0]}
                gaTitle={data.product.name}
                gaName={data.product.name}
                gaPrice={data.product.option.priceasnumber}
                gaPromoPrice={data.product.option.promotionpriceasnumber}
                gaQuantity={1}
                gaVariant={
                  data.product.attributes.colour &&
                  data.product.attributes.colour[0]
                }
                gaCurrency={currency}
                gaSizeSelected={sizeSelect ? true : false}
                gaSale={data.product.option.onsale}
                gaDisabled={!data.product.instock}
                buttonSlotNumber={1}
                buttonColour="black"
                buttonLinkContent={
                  !data.product.instock
                    ? 'Out of stock'
                    : sizeError
                    ? 'Select Size'
                    : atbButtonTxt
                }
                setClick={true}
                clickProperties={(e) => {
                  checkSizeSelected(false); // Check size is selected
                  prodSku && sizeSelect && addToBasketViaElite(e);
                  if (atbButtonTxt === 'Add to bag') {
                    ppHeadingOverridesOpen();
                  }
                }}
              />
            */}
          </>
        )}
      </div>
    </>
  );
};

export default ProductSizes;
